module.exports = __webpack_public_path__ + "img/en-pc-banner.3840270c.png";